import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const ContainerGeral = styled.div`
  width: 100%;
  height: auto;
  max-width: 420px;

  gap: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 479px) {
    align-items: flex-start;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  height: auto;
  background: transparent;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 880px;
  padding: 36px 36px 30px 36px;
  height: ${props => ( !props.openBox ? props.existInformation ? 'auto' : 'auto' : 'auto')};

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: ${props => (!props.openBox ? 'space-between' : 'flex-start')};
  
  border-radius: 8px;
  margin: 20px auto 20px;
  background-color: ${props => (props.disabled ? theme.colors.disabled.Fundo_Desabilitado : "#FFF")};
  color: ${props => (props.disabled ? theme.colors.disabled.Desabilitado_Medio : '#303848')};
  border: ${props => (props.erro ? 'solid 2px #ff5252' : '2px solid #F3F3F5')};
  
  transition: all 0.2s;

  .row{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .arrow {
      width: 20px;
      height: auto;

      opacity: ${props => (props.disabled ? "0.5" : "1")};

      transform: ${props => (!props.openBox ? 'none' : 'rotate(180deg)')};
      transition: all 0.2s;
      &:hover {
        cursor: pointer;
        transform: ${props => (!props.openBox ? 'scale(1.2) rotate(0deg)' : 'scale(1.2) rotate(180deg)')};
      }

      &:active {
        transform: scale(0.8);
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    /* width: 100%;
    height: auto;
    margin: 20px 0px 20px;
    padding: 36px 36px 30px 36px; */
  }

  @media only screen and (max-width: 780px) {
    width: 100%;
    height: ${props => ( !props.openBox ? props.existInformation ? 'auto' : 'auto' : 'auto')};
    margin: 0px;
    margin-top: 20px;
    padding: 36px 5% 30px 5%;

    .row{
      gap: 16px;
      justify-content: space-between;

        @media only screen and (max-width: 780px) {
          >h6{
            font-size: 21px;
          }
        }
    }

  }
`;

export const Paragraph = styled.p`
  width: 100%;
  margin: 18px 0 0;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${props => (props.disabled? theme.colors.disabled.Desabilitado_Medio : '#21262F')};
`;

export const RowInfo = styled.div`
  width: 100%;
  margin: 18px 0 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  @media only screen and (max-width: 780px) {
    gap: 24px;
    flex-direction: column;
  }
`;

export const ColInfo = styled.div`
  width: auto;
  min-width: 130px;

  gap: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  ~ div {
    margin-left: 48px;
  }

  @media only screen and (max-width: 780px) {
    ~ div {
      margin-left: 0px !important;
    }    
  }
`;

// export const Label = styled.label`
//   font-family: Lato;
//   font-size: 11px;
//   font-weight: bold;
//   font-stretch: normal;
//   font-style: normal;
//   line-height: normal;
//   letter-spacing: normal;
//   color: ${props => (props.disabled? `${theme.colors.disabled.Desabilitado_Claro}` : props.erro ? `${theme.colors.red.Vermelho_erro}` : '#bac1cf')};

//   @media only screen and (max-width: 780px) {
//     margin-bottom: 0px !important;
//   }

// `;

export const Texto = styled.p`
  margin: 0px;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props => (props.disabled? `${theme.colors.disabled.Desabilitado_Claro}` : props.erro ? `${theme.colors.red.Vermelho_erro}` : '#303848')};
  height: 17px;

  @media only screen and (max-width: 780px) {
    margin-bottom: 10px !important;
  }

`;

export const ContainerInfoText = styled.div`
  width: auto;
  height: 24px;
  max-width: 260px;
  padding: 4px 8px;

  gap: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 5rem;
  background-color: ${props => (props.bgColor ? props.bgColor : theme.colors.gray.Cinza_12)};

  > span {
    max-width: 100%;

    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    text-overflow: ellipsis;
  }
`;

export const ContainerForm = styled.div`
  width: 100%;
  /* max-width: 300px; */

  height: auto;
  /* padding-right: 270px;
  padding-left: 270px; */

  display: flex;
  align-items: center;
  flex-direction: column;

  padding-top: 30px;
  margin-top: 36px;
  border-top: 2px solid ${theme.colors.gray.Cinza_12};
  overflow-y: scroll;
  overflow-x: hidden;

  @media only screen and (max-width: 1024px) {
    /* padding-right: 25%;
    padding-left: 25%; */
  }

  @media only screen and (max-width: 780px) {
    padding-right: 1%;
    padding-left: 1%;
    height: auto;

  }

  /* width */
  ::-webkit-scrollbar {
    width: 0px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888; 
    border-radius: 8px;
    
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
`;

export const ContainerFooter = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  /* @media (max-width: 479px) {
    margin-top: 16px;
  } */
`

export const Footer = styled.div`
  width: auto;
  height: auto;
  padding: 4px 4px 4px 8px;

  gap: 4px;
  display: flex;
  margin-top: 4px;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  border-radius: 5rem;
  background-color: ${theme.colors.gray.Cinza_12};
  
  .pin{
    width: 12px;
    height: auto;
  }
  
  >p {
    text-align: center;
  }
`;